// @flow
import {
  FETCH_ALL_CUSTOMERS,
  FETCH_ALL_CUSTOMERS_SUCCESS,
  FETCH_ALL_CUSTOMERS_ERROR,
  INVITE_CUSTOMER,
  INVITE_CUSTOMER_SUCCESS,
  INVITE_CUSTOMER_ERROR,
  DELETE_CUSTOMER,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_ERROR,
} from '../actions/customersActions';
import RadioCustomer from '../types/RadioCustomer';
import type { CustomersState } from '../types/State';

export const INITIAL_STATE: CustomersState = {
  customerInvitation: {
    sending: false,
    error: false,
  },
  customerDeletion: {
    deleting: false,
    error: false,
  },
  fetching: false,
  customers: [],
  error: false,
};

export default (state: CustomersState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case FETCH_ALL_CUSTOMERS:
      return {
        ...state,
        fetching: true,
        error: false,
      };
    case FETCH_ALL_CUSTOMERS_SUCCESS:
      return {
        ...state,
        fetching: false,
        customers: action.customers,
      };
    case FETCH_ALL_CUSTOMERS_ERROR:
      return {
        ...state,
        fetching: false,
        error: true,
      };
    case INVITE_CUSTOMER:
      return {
        ...state,
        customerInvitation: {
          ...state.customerInvitation,
          sending: true,
          error: false,
        },
      };
    case INVITE_CUSTOMER_SUCCESS: {
      const customers = state.customers.slice();
      if (customers.findIndex(customer => customer.isSameAs(action.customer)) === -1) {
        customers.push(action.customer);
      }

      return {
        ...state,
        customerInvitation: {
          ...state.customerInvitation,
          sending: false,
        },
        customers: customers,
      };
    }
    case INVITE_CUSTOMER_ERROR:
      return {
        ...state,
        customerInvitation: {
          ...state.customerInvitation,
          sending: false,
          error: true,
        },
      };
    case DELETE_CUSTOMER:
      return {
        ...state,
        customerDeletion: {
          ...state.customerDeletion,
          deleting: true,
          error: false,
        },
      };
    case DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        customerDeletion: {
          ...state.customerDeletion,
          deleting: false,
        },
        customers: state.customers.filter((customer: RadioCustomer) => !customer.isSameAs(action.customer)),
      };
    case DELETE_CUSTOMER_ERROR:
      return {
        ...state,
        customerDeletion: {
          ...state.customerDeletion,
          error: true,
          deleting: false,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/reducers/customersReducer.js